import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import MissingExchangeRatesReportCriteria from './MissingExchangeRatesReportCriteria';

@NeoReport("MissingExchangeRates", { category: MaintenanceReportCategories.DataValidationReports })
export default class MissingExchangeRatesReport extends Report<MissingExchangeRatesReportCriteria> {

    constructor() {
        super(MissingExchangeRatesReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={3} md={3}>
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.startDate}
                    />
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.endDate}
                    />
                </Neo.GridLayout>
            </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}